import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'landing/:slug',
    loadComponent: () =>
      import('./features/landing-shell/landing-shell.component').then(
        m => m.LandingShellComponent
      ),
  },
  {
    path: '',
    redirectTo: 'landing/demo',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'landing/demo',
  },
];
